import {useQuery} from "@tanstack/react-query";
import {
    readDashboardSetting,
    readRevenueByItem,
    readRevenueByTeamByQuarter, readRevenueByTeamByYear
} from "../../../../../api/main/DashboardApi";
import {DashboardSettingSearchParamType} from "../interface";

export const useReadRevenueByTeamByYear = () => {
    const {data} = useQuery({
        queryKey: ["readRevenueByTeamByYear"],
        queryFn: async () => await readRevenueByTeamByYear(),
        select: (res) => res?.data.result ?? [],
    });

    return {data};
};
